<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import axios from "axios";
import Swal from "sweetalert2";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Socios",
            items: [
                { text: "Inicio", href: "/" },
                { text: "Socios", active: true }
            ],
            search: "",
            socios: [],
            form: { id: null, nombre: "", rut: "", correo: "" },
            isLoading: false,
            nameState: null,
            rutState: null,
            emailState: null,
            cafes_cange:0
        };
    },
    computed: {
        formValid() {
            return this.nameState && this.rutState && this.emailState;
        },
        filteredSocios() {
            const term = this.search.trim().toLowerCase();
            return term
                ? this.socios.filter(s =>
                    s.nombre.toLowerCase().includes(term) ||
                    s.rut.toLowerCase().includes(term) ||
                    s.correo.toLowerCase().includes(term) ||
                    s.codigo.toLowerCase().includes(term)
                )
                : this.socios;
        }
    },
    watch: {
        "form.nombre": "validateName"
    },
    methods: {
        async fetch() {
            this.isLoading = true;
            try {
                const response = await axios.get('/api/socios');
                // extraemos socios y, si quisieras, cafes_cange
                this.socios      = response.data.socios;
                this.cafes_cange = response.data.cafes_cange;
            } catch {
                this.$toasted.error("Error cargando socios");
            } finally {
                this.isLoading = false;
            }
        },
        resetForm() {
            this.form = { id: null, nombre: "", rut: "", correo: "" };
            this.nameState = this.rutState = this.emailState = null;
        },
        validateName() {
            this.nameState = this.form.nombre.trim().length > 0;
        },
        onRutInput(raw) {
            let clean = raw.replace(/[^0-9kK]/g, "").toUpperCase();
            if (clean.length < 2) {
                this.form.rut = clean;
                this.rutState = null;
                return;
            }
            const body = clean.slice(0, -1);
            const dv = clean.slice(-1);
            const reversed = body.split("").reverse().join("");
            const chunks = reversed.match(/.{1,3}/g) || [];
            const formattedBody = chunks.join(".").split("").reverse().join("");
            this.form.rut = `${formattedBody}-${dv}`;
            this.validateRut();
        },
        validateRut() {
            const rut = this.form.rut.replace(/[^0-9kK]/g, "").toUpperCase();
            const body = rut.slice(0, -1), dv = rut.slice(-1);
            let sum = 0, mult = 2;
            for (let i = body.length - 1; i >= 0; i--) {
                sum += parseInt(body[i]) * mult;
                mult = mult === 7 ? 2 : mult + 1;
            }
            const res = 11 - (sum % 11);
            const dvExpected = res === 11 ? "0" : res === 10 ? "K" : res.toString();
            this.rutState = dvExpected === dv;
        },
        validateEmail() {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(\".+\"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;
            this.emailState = re.test(this.form.correo);
        },
        async save() {
            this.validateName();
            this.validateRut();
            this.validateEmail();
            if (!this.formValid) return;

            this.isLoading = true;
            
                if (this.form.id) {
                    await axios.put(`/api/socios/${this.form.id}`, this.form);
                    this.$toasted.success("Socio actualizado");
                } else {
                    const { socio } = await axios.post("/api/socios", this.form);
                    console.log(socio);
                    this.$toasted.success("Socio creado");
                    Swal.fire({
                        icon: "success",
                        title: "Codigo de socio: "+ socio.codigo,
                        showConfirmButton: true,
                        timer: 15000
                    });
                }
                this.resetForm();
                this.fetch();
                try {
            } catch {
                this.$toasted.error("Error guardando socio");
            } finally {
                this.isLoading = false;
            }
        },
        edit(s) {
            this.form = { ...s };
            this.validateName();
            this.rutState = null;
            this.emailState = null;
        },
        async remove(id) {
            if (!confirm("¿Eliminar este socio?")) return;
            this.isLoading = true;
            try {
                await axios.delete(`/api/socios/${id}`);
                this.$toasted.success("Socio eliminado");
                this.fetch();
            } catch {
                this.$toasted.error("Error eliminando socio");
            } finally {
                this.isLoading = false;
            }
        },
        async increment(s) {
            this.isLoading = true;
            try {
                await axios.post(`/api/socios/${s.id}/increment`);
                this.$toasted.success("Café contado");
                this.fetch();
            } catch {
                this.$toasted.error("Error contando café");
            } finally {
                this.isLoading = false;
            }
        }
    },
    mounted() {
        this.fetch();
    }
};
</script>

<style scoped>
.table td,
.table th {
    vertical-align: middle;
}
</style>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <!-- Formulario crear/editar socio (full width) -->
        <div class="row mb-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-body p-3">
                        <div class="col-6">
                        <b-form @submit.prevent="save">
                                <!-- Nombre -->
                                <b-form-group label="Nombre" label-cols-sm="2" label-cols-md="1" label-cols-lg="1"
                                    :state="nameState" invalid-feedback="El nombre no puede estar vacío">
                                    <b-form-input v-model="form.nombre" placeholder="Nombre" :state="nameState" />
                                </b-form-group>

                                <!-- RUT -->
                                <b-form-group label="RUT" label-cols-sm="2" label-cols-md="1" label-cols-lg="1"
                                    :state="rutState" invalid-feedback="RUT inválido">
                                    <b-form-input :value="form.rut" @input="onRutInput" placeholder="12.345.678-K"
                                        :state="rutState" />
                                </b-form-group>

                                <!-- Correo -->
                                <b-form-group label="Correo" label-cols-sm="2" label-cols-md="1" label-cols-lg="1"
                                    :state="emailState" invalid-feedback="Correo inválido">
                                    <b-form-input v-model="form.correo" type="email" placeholder="correo@ejemplo.cl"
                                        :state="emailState" @blur="validateEmail" />
                                </b-form-group>

                                <!-- Botones -->
                                <div class="col-12 text-right">
                                    <b-button type="submit" :variant="form.id ? 'warning' : 'success'"
                                        :disabled="!formValid">
                                        {{ form.id ? 'Actualizar' : 'Agregar' }}
                                    </b-button>
                                    <b-button v-if="form.id" variant="secondary" @click="resetForm" class="ml-2">
                                        Cancelar
                                    </b-button>
                                </div>
                            </b-form>
                        </div>
                        <div class="col-5">
                            <p>Por {{ cafes_cange}} cafes uno gratis!</p>
                        </div>
                        <loading-message v-if="isLoading" class="mt-2" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabla de socios (full width) -->
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- Filtro de búsqueda -->
                    <div class="card-body p-2">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="d-flex justify-content-end">
                                    <b-form-input v-model="search" placeholder="Buscar por Nombre, RUT, Correo o Código" class="w-25" />
                                </div>
                            </div>
                        </div>
                        <table class="table mb-0">
                            <thead>
                                <tr>
                                    <th class="py-1 px-2">#</th>
                                    <th class="py-1 px-2">Código</th>
                                    <th class="py-1 px-2">Nombre</th>
                                    <th class="py-1 px-2">RUT</th>
                                    <th class="py-1 px-2">Correo</th>
                                    <th class="py-1 px-2">Cafés</th>
                                    <th class="py-1 px-2"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, i) in filteredSocios" :key="s.id">
                                    <td class="py-1 px-2">{{ i + 1 }}</td>
                                    <td class="py-1 px-2">{{ s.codigo }}</td>
                                    <td class="py-1 px-2">{{ s.nombre }}</td>
                                    <td class="py-1 px-2">{{ s.rut }}</td>
                                    <td class="py-1 px-2">{{ s.correo }}</td>
                                    <td class="py-1 px-2">
                                        {{ s.coffee_count }}
                                        <!-- <button class="btn btn-sm btn-success ml-1 py-0 px-1" @click="increment(s)">
                                            +1
                                        </button> -->
                                    </td>
                                    <td class="py-1 px-2">
                                        <div class="btn-group">
                                            <button class="btn btn-sm btn-primary py-0 px-1" @click="edit(s)">
                                                <i class="fas fa-edit"></i>
                                            </button>
                                            <button class="btn btn-sm btn-danger py-0 px-1" @click="remove(s.id)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <loading-message v-if="isLoading" />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>